import { POYO_MODELS, categoryDisplayLabel } from "../categories";
import { normalizeCategoryId } from "../studioGenerationMode";

const STATUS_META = {
  pending: { key: "videoLibraryStatusPending", fallback: "Pending", color: "default" },
  generating: { key: "videoLibraryStatusGenerating", fallback: "Generating", color: "warning" },
  completed: { key: "videoLibraryStatusCompleted", fallback: "Ready", color: "success" },
  failed: { key: "videoLibraryStatusFailed", fallback: "Failed", color: "error" },
};

export function jobStatusMeta(status, lang) {
  const meta = STATUS_META[status] || {
    key: null,
    fallback: status || "Unknown",
    color: "default",
  };
  return {
    label: (meta.key && lang?.[meta.key]) || meta.fallback,
    color: meta.color,
  };
}

export function jobCategoryLabel(categoryId, lang) {
  if (categoryId === "upload") {
    return lang?.videoLibraryCatUpload || "Uploaded video";
  }
  if (categoryId === "stitch") {
    return lang?.videoLibraryCatStitch || "Stitched video";
  }
  return categoryDisplayLabel(normalizeCategoryId(categoryId), lang);
}

export function jobModelLabel(uiModel, lang) {
  if (uiModel === "user-upload") {
    return lang?.videoLibraryModelUpload || "Your upload";
  }
  if (uiModel === "video-stitch") {
    return lang?.videoLibraryModelStitch || "Joined export";
  }
  return POYO_MODELS[uiModel]?.label || uiModel || "—";
}

export function formatJobDate(value) {
  if (!value) return "—";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleString(undefined, {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
}

/** Client-side safety net when API status filter is missing (e.g. stale backend). */
export function filterJobsByStatus(jobs, statusFilter) {
  if (!statusFilter) return jobs;
  if (statusFilter === "processing") {
    return jobs.filter((j) => j.status === "pending" || j.status === "generating");
  }
  return jobs.filter((j) => j.status === statusFilter);
}

export function truncatePrompt(text, max = 120) {
  const s = String(text || "").trim();
  if (!s) return "";
  if (s.length <= max) return s;
  return `${s.slice(0, max)}…`;
}
